define([
  'react',
  'prop-types',
], (React, PropTypes) => {
  class ChipDivider extends React.PureComponent {
    render() {
      return (
        <div className="bdow-flex bdow-my-16">
          <div className="bdow-chip-line-divider" />
          <div className="bdow-chip-divider">
            {this.props.label}
          </div>
          <div className="bdow-chip-line-divider" />
        </div>
      );
    }
  }

  ChipDivider.propTypes = {
    label: PropTypes.string,
  };

  return ChipDivider;
});
